import { contactInfo } from '@/mocks/homeData';

export default function MapSection() {
  return (
    <section id="localizacao" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="w-full lg:w-2/5">
            <span className="text-xs uppercase tracking-[0.2em] text-primary-500 font-semibold mb-3 block">
              Onde Estamos
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight mb-6">
              Faria Lima,<br />coração de São Paulo
            </h2>
            <p className="text-foreground-600 text-base leading-relaxed mb-8">
              Estamos estrategicamente localizados na Av. Brigadeiro Faria Lima, uma das regiões mais valorizadas de São
              Paulo, com fácil acesso por transporte público, carro ou aplicativo.
            </p>

            <div className="space-y-4 mb-8">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg flex-shrink-0">
                  <i className="ri-map-pin-line text-accent-600 text-lg"></i>
                </div>
                <div>
                  <p className="font-semibold text-foreground-950 text-sm">Endereço</p>
                  <p className="text-foreground-600 text-sm">{contactInfo.address}</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg flex-shrink-0">
                  <i className="ri-train-line text-accent-600 text-lg"></i>
                </div>
                <div>
                  <p className="font-semibold text-foreground-950 text-sm">Metrô</p>
                  <p className="text-foreground-600 text-sm">Estação Faria Lima (5 min a pé)</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg flex-shrink-0">
                  <i className="ri-car-line text-accent-600 text-lg"></i>
                </div>
                <div>
                  <p className="font-semibold text-foreground-950 text-sm">Estacionamento</p>
                  <p className="text-foreground-600 text-sm">Valet service disponível no local</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg flex-shrink-0">
                  <i className="ri-time-line text-accent-600 text-lg"></i>
                </div>
                <div>
                  <p className="font-semibold text-foreground-950 text-sm">Horários</p>
                  <p className="text-foreground-600 text-sm">Seg-Sex: 8h às 19h | Sáb: 8h às 13h</p>
                </div>
              </div>
            </div>

            <a
              href={`https://wa.me/${contactInfo.whatsapp}?text=Olá!%20Gostaria%20de%20agendar%20uma%20avaliação.`}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="whitespace-nowrap inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white text-sm font-semibold px-8 py-3.5 rounded-full transition-all duration-300 cursor-pointer"
            >
              Agendar Minha Consulta
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="w-full lg:w-3/5">
            <div className="rounded-2xl overflow-hidden h-[400px] md:h-[500px] w-full">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3657.2!2d-46.6847!3d-23.5832!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce5744e0b6bf5b%3A0x5e0b6fbf3b6b8b4e!2sAv.%20Brigadeiro%20Faria%20Lima%2C%202355%20-%20Itaim%20Bibi%2C%20S%C3%A3o%20Paulo%20-%20SP!5e0!3m2!1spt-BR!2sbr!4v1690000000000"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Localização do consultório Dra. Marihana Pasquali na Faria Lima"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}